/** Die Haus-Zustände und woraus sie gebaut werden. */
import type { HouseKey } from "@hausplaner/model";
import { WALLS, type WallDef } from "./walls";
import { ROOMS, type RoomDef } from "./rooms";
import { PLANUNG_ROOMS, PLANUNG_WALLS } from "./planung";

export interface Variant { walls: WallDef[]; rooms: RoomDef[] }

export const VARIANTS: Record<HouseKey, Variant> = {
  bestand: { walls: WALLS, rooms: ROOMS },
  planung: { walls: PLANUNG_WALLS, rooms: PLANUNG_ROOMS },
};
